import TicketItem from "./item";

const TicketsList = props => {

    const {raffle} = props

    return (
        <ul className="row">
            {
                raffle
                    ?.tickets
                    ?.map((ticket, i) => <TicketItem
                        key={i}
                        // title={raffle?.name}
                        ticket={ticket}/>)
            }
        </ul>

    )

}


export default TicketsList
